import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";

export function useOutgoingMailActions(onCountsChange) {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "outgoing-mail-list"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "outgoing-mail-list",
      data: data,
    });
  };

  const fetchOutgoingMail = async (id) => {
    return await backendGet(`/data/outgoing-mails/${id}`, {
      label: "Ausgehende E-Mail laden",
      enqueueSnackbar,
    });
  };

  return {
    fetchOutgoingMail,
    setState,
    state,
  };
}
